import { render, staticRenderFns } from "./WidgetSoilSamples.vue?vue&type=template&id=7ce36699&scoped=true&"
import script from "./WidgetSoilSamples.vue?vue&type=script&lang=js&"
export * from "./WidgetSoilSamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce36699",
  null
  
)

export default component.exports